import { useEffect } from "react";
import { COPY_STRINGS } from "../../../../constants/translatedCopy";
import { getCopyByGradeband } from "../../../../services/ThemingService";

export default function useNetworkSpeedError({currentError, speechProps}){

    useEffect(()=>{
        // optionally handle each currentError individually
        if(currentError){
            const studentChecks = getCopyByGradeband(COPY_STRINGS, 'student_checks');
            // Amira speech and gesture.
            speechProps.speak({
                textToSpeak: studentChecks.network_speed_error_one + studentChecks.network_speed_error_two,
            })
        }
    }, [currentError])
}